(function () {
  // Sadece valentinovo koleksiyonu
  if (window.location.pathname !== "/collections/valentinovo") return;

  function rand(min, max) { return Math.random() * (max - min) + min; }
  function pick(arr) { return arr[Math.floor(Math.random() * arr.length)]; }

  // Daha pürüzsüz SVG kalp (emoji değil)
  const svgHeart = (color) => `
    <svg viewBox="0 0 24 24" width="24" height="24" aria-hidden="true" focusable="false">
      <path d="M12 21s-7.2-4.35-9.6-8.55C.6 9 .9 5.7 3.3 4.05 5.4 2.55 8.25 3.15 10.05 5.1L12 7.2l1.95-2.1c1.8-1.95 4.65-2.55 6.75-1.05 2.4 1.65 2.7 4.95.9 8.4C19.2 16.65 12 21 12 21z"
            fill="${color}"/>
    </svg>
  `;

  const colors = [
    "rgba(255, 80, 130, 0.95)",  // pembe
    "rgba(255, 35, 90, 0.95)",   // kırmızı-pembe
    "rgba(255, 255, 255, 0.95)"  // beyaz
  ];

  // CSS'i JS içinden basalım (tema dosyalarına dokunma gerektirmesin)
  function injectCSSOnce() {
    if (document.getElementById("nt-floating-hearts-css")) return;

    const style = document.createElement("style");
    style.id = "nt-floating-hearts-css";
    style.textContent = `
      .floating-heart{
        position: fixed;
        left: 0;
        bottom: -30px;
        width: var(--size, 18px);
        height: var(--size, 18px);
        pointer-events: none;
        z-index: 9999;
        filter: blur(var(--blur, 0px));
        transform: translate3d(0,0,0);
        will-change: transform, opacity;
        animation: ntHeartFloat var(--duration, 6s) linear forwards;
      }
      .floating-heart svg{
        display:block;
        width: 100%;
        height: 100%;
      }
      @keyframes ntHeartFloat{
        0%{
          transform: translate3d(0, 0, 0) rotate(0deg);
          opacity: 0;
        }
        10%{ opacity: var(--op, 0.9); }
        100%{
          transform: translate3d(var(--drift, 0px), calc(-1 * (100vh + 80px)), 0) rotate(var(--rotate, 0deg));
          opacity: 0;
        }
      }
    `;
    document.head.appendChild(style);
  }

  function createHeart() {
    const heart = document.createElement("div");
    heart.className = "floating-heart";

    const startX = rand(0, window.innerWidth);
    const size = rand(12, 26);
    const duration = rand(4, 8);
    const drift = rand(-140, 140);
    const rotate = rand(-18, 18);
    const blur = rand(0, 0.6);
    const op = rand(0.65, 1).toFixed(2);

    heart.style.left = startX + "px";
    heart.style.setProperty("--size", size + "px");
    heart.style.setProperty("--duration", duration + "s");
    heart.style.setProperty("--drift", drift + "px");
    heart.style.setProperty("--rotate", rotate + "deg");
    heart.style.setProperty("--blur", blur + "px");
    heart.style.setProperty("--op", op);

    heart.innerHTML = svgHeart(pick(colors));

    document.body.appendChild(heart);
    setTimeout(() => heart.remove(), duration * 1000 + 400);
  }

  let timer = null;

  function start() {
    if (timer) return;
    injectCSSOnce();
    createHeart();
    createHeart(); // ilk kalp hemen çıksın
    timer = setInterval(createHeart, 320);
  }

  function stop() {
    if (!timer) return;
    clearInterval(timer);
    timer = null;
  }

  // başlat
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }

  // sekme gizlenince durdur, geri gelince devam
  document.addEventListener("visibilitychange", () => {
    if (document.hidden) stop();
    else start();
  });
})();
